module.exports = __webpack_public_path__ + "static/media/challenge-background-init-mountains.07e167c4.svg";